<template>
  <div class="licenseWrap" v-loading="loading">
    <div class="licenseConentWrap">
      <div class="licenseTitle">
        <span>License 激活申请</span>
        <el-tooltip popper-class="tooltipCustom" effect="dark" placement="right">
          <div slot="content">
            <div class="textWrap">
              <div style="margin-bottom: 6px;">如果您对向导中任何展示和输入信息存在疑问，请中止操作，并<span class="clickText" @click="clickTextFuc">联系我们</span>或致电400-6888-311帮助您完成该操作</div>
              <div>建议使用浏览器：Chrome 62及以上版本；IE 10及以上版本；Firefox 60及以上版本。</div>
            </div>
          </div>
          <i class="el-icon-warning-outline licenseTitleIcon"></i>
        </el-tooltip>
      </div>
      <div class="licenseHeader">
        <nav-list
          class="navList"
          :stepList="stepList"
          :currentStep="currentStep"
        ></nav-list>
      </div>
      <div class="licenseContent">
        <keep-alive>
          <components
            :is="comList[currentStep].com"
            ref="commonRef"
          ></components>
        </keep-alive>
        <!-- <add-info ref="addInfo" v-if="currentStep === 0"></add-info>
        <bind-device ref="bindDevice" v-if="currentStep === 1"></bind-device>
        <user-info ref="userInfo" v-if="currentStep === 2"></user-info>
        <confirm-active ref="confirmActive" v-if="currentStep === 3"></confirm-active> -->
      </div>
      <!-- <div class="licenseContent">
        <add-info ref="addInfo" v-if="currentStep === 0"></add-info>
        <bind-device ref="bindDevice" v-if="currentStep === 1"></bind-device>
        <user-info ref="userInfo" v-if="currentStep === 2"></user-info>
        <confirm-active ref="confirmActive" v-if="currentStep === 3"></confirm-active>
      </div> -->
    </div>
    <div class="licenseFooter">
      <div class="footerWrap">
        <clause-tip ref="clauseTip" v-if="currentStep === 1">
          <div>我已了解：授权码与硬件设备绑定后，对应的授权就与硬件设备进行了绑定</div>
          <div>进行绑定操作时，请确保输入信息的准确，以免因授权码与硬件设备的错误绑定，导致目标设备没有获得正确的授权。</div>
        </clause-tip>
        <clause-tip ref="clauseTip" v-if="currentStep === 3 && (!activateState)">
          <div>已阅读并同意法律声明所述服务条款各项内容<span class="clickText" @click.stop="clickTextFour">紫光云授权服务门户法律声明</span></div>
        </clause-tip>
        <div class="footerRight">
          <verify-code class="verifyCode" ref="verifyCode" v-if="currentStep === 2"></verify-code>
          <el-button type="primary" plain v-show="currentStep !== 0 && (!activateState)" @click="previousPage">上一步</el-button>
          <el-button type="primary" v-show="currentStep !== (stepList.length - 1)" @click="nextPage">下一步</el-button>
          <el-button type="primary" v-show="currentStep === (stepList.length - 1) && (!activateState)" @click="activeLicenseFuc">确认并激活License</el-button>
          <el-button type="primary" plain v-if="activateState" @click="batchGetActiveInfo">批量获取激活信息</el-button>
          <el-button type="primary" v-if="activateState" @click="continueActive">继续激活</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import requestActiveLicense from "~/request/requestActiveLicense";
import navList from "~/components/nav-list.vue";
import AddInfo from "./Components/AddInfo.vue";
import BindDevice from "./Components/BindDevice.vue";
import UserInfo from "./Components/UserInfo.vue";
import VerifyCode from "./Components/VerifyCode.vue";
import clauseTip from "~/components/clause-tip.vue";
import ConfirmActive from "./Components/ConfirmActive.vue";
import { mapState } from "vuex";
import {activeLicense} from '~/request/configActiveLicense';
export default {
  components:{
    navList,
    AddInfo,
    BindDevice,
    UserInfo,
    VerifyCode,
    clauseTip,
    ConfirmActive
  },
  data(){
    return{
      loading: false,
      // 校验项
      vailList:[['commonRef'], ['commonRef', 'clauseTip'], ['commonRef', 'verifyCode']],
      // vailList:[['commonRef'], [ 'clauseTip'], ['commonRef', 'verifyCode'], ''],
      // vailList:['', '', '', ''],
      // 组件名
      // comList: ['addInfo', 'bindDevice', 'userInfo', 'confirmActive'],
      comList: [
        {
          com: 'addInfo',
          vailAfter: true
          // vailAfter: false
        }, 
        {
          com: 'bindDevice',
          vailAfter: true
          // vailAfter: false
        }, 
        {
          com: 'userInfo',
          vailAfter: true
          // vailAfter: false
        }, 
        {
          com: 'confirmActive',
          // vailAfter: true
          vailAfter: false
        }
      ],
      currentStep: 0,
      stepList:[
        {label:'第一步：输入授权信息'},
        {label:'第二步：绑定硬件设备'},
        {label:'第三步：用户数据录入'},
        {label:'第四步：确认并激活'},
      ],
      // 激活状态
      activateState: false
    }
  },
  computed:{
    ...mapState(['tableData', 'processId', 'checkTableData', 'cacheKey', 'bindTableData'])
  },
  async created(){
    // let res =  await requestActiveLicense.createProcessId();
    // if(res.data && res.data.res){
    //   this.$store.commit('setProcessId', res.data.res);
    // }
    // console.log('processId===', this.$store.state.processId);
    // window.qq = this;
  },
  methods:{
    clickTextFour(){
      window.open(`${location.origin}/document/license_activation_legal.html`);
    },
    clickTextFuc(){
      window.open(`${location.origin}/contact/index.html`);
    },
    batchGetActiveInfo(){
      let activeTableData = this.$refs.commonRef.getActiveTableData();
      if(!activeTableData){
        return;
      }
      const param = {
        'activeId': activeTableData.map(item => item.activeId),
        'cacheKey': this.cacheKey
      }
      requestActiveLicense.fileDownloadBatch(param).then(res =>{
        console.log('fileDownloadBatch res===', res);
        if(!res){
          window.location.href = `${window.location.origin}${activeLicense.fileDownloadBatch}?activeId=${param.activeId.join(',')}&cacheKey=${param.cacheKey}`;
          return;
        }
        if(res.code == '0'){
          this.$confirm(
            res.msg, '激活结果提示', 
            {
              confirmButtonText: '确定',
              showCancelButton: false,
              closeOnClickModal: false,
              customClass: 'confirmClass',
              type: 'other',
            }).then(() => {});
        }
      }).catch(err=>{})
    },
    continueActive(){
      // 清空 store 数据，将 currentStep 置为 0，activateState 置为 false
      this.$store.commit('clearProcessInfo');
      this.activateState = false;
      this.currentStep = 0;
    },
    previousPage(){
      this.currentStep -= 1;
    },
    nextPage(){
      const hanlderRef = this.vailList[this.currentStep];
      let refList = [];
      if(Array.isArray(hanlderRef)){
        console.log('this.$refs.commonRef===', this.$refs.commonRef);
        refList = hanlderRef.map(hander => this.$refs[hander].getVail());
      }
      Promise.all(refList)
      .then(() => {
          console.log('成功');
          let fuc = '';
          if(this.comList[this.currentStep].vailAfter){
            fuc = this.comList[this.currentStep].com + 'Vail';
          }
          if(fuc){
            this[fuc]()
          }else{
            this.currentStep += 1;
          }
      })
      .catch(() => {
          console.log('失败');
      })
    },
    userInfoVail(){
      let param = this.$refs.commonRef.getData();
      param.processId = this.processId;
      this.loading = true;
      requestActiveLicense.saveUserInfo(param).then(res =>{
        if (res.code == '0') {
          const stepParam = {
            'list': this.checkTableData,
            'processId': this.processId,
            'cacheKey': this.cacheKey,
            'nextIndex': '4',
            ...param
          }
          requestActiveLicense.step(stepParam).then(res =>{
            this.loading = false;
            if (res.code == '0') {
              this.$store.commit('setCacheKey', res.res.cacheKey);
              this.currentStep += 1;
              // this.$notify({
              //   title: '成功',
              //   message: res.msg || '操作成功',
              //   type: 'success',
              // });
            }
          }).catch(err =>{
            this.loading = false;
            this.$notify({
              title: '失败',
              message: '操作失败',
              type: 'error',
            });
          })
        }
      }).catch(err => {
        this.loading = false;
        this.$notify({
          title: '失败',
          message: '操作失败',
          type: 'error',
        });
      })

    },
    bindDeviceVail(){
      const param = {
        'list': this.checkTableData,
        'processId': this.processId,
        'cacheKey': this.cacheKey,
        'nextIndex': '3'
      }
      this.loading = true;
      requestActiveLicense.stepValidate(param).then(res =>{
        if (res.code == '0') {
          this.$refs.commonRef.showTip(res.res.data, err =>{
            if(err){
              this.loading = false;
            }else{
              requestActiveLicense.step(param).then(res =>{
                this.loading = false;
                if (res.code == '0') {
                  this.currentStep += 1;
                  // this.$notify({
                  //   title: '成功',
                  //   message: res.msg || '操作成功',
                  //   type: 'success',
                  // });
                }
              }).catch(err =>{
                this.loading = false;
                this.$notify({
                  title: '失败',
                  message: '操作失败',
                  type: 'error',
                });
              })
            }
          });
        }else{
          this.loading = false;
        }
      }).catch(err =>{
        this.loading = false;
        this.$notify({
          title: '失败',
          message: '操作失败',
          type: 'error',
        });
      })
    },
    addInfoVail(){
      const param = {
        'list': this.checkTableData,
        'processId': this.processId,
        'cacheKey': this.cacheKey,
        'nextIndex': '2'
      }
      this.loading = true;
      requestActiveLicense.step(param).then(res =>{
        this.loading = false;
        console.log(' step res===', res);
        if (res.code == '0') {
          this.$store.commit('setCacheKey', res.res.cacheKey);
          this.currentStep += 1;
          // this.$notify({
          //   title: '成功',
          //   message: res.msg || '操作成功',
          //   type: 'success',
          // });
        }
      }).catch(err =>{
        this.loading = false;
        this.$notify({
          title: '失败',
          message: '操作失败',
          type: 'error',
        });
      })
    },
    activeLicenseFuc(){
      this.$refs['clauseTip'].getVail().then(()=>{
        const param = {
          'cacheKey': this.cacheKey,
          'licenseKeyList': this.checkTableData.map(item => item.licenseKey),
          // 'licenseKeyList': ['3130A54C-kjRe$aeF-/7teYV4F-AYJFyfyp', '3130A59X-%EsK&/v7-as*Ux#W$-jeN@%&hJ', '3130A59X-JMPfCNbT-tRBg#m$d-J2Ryw3+c'],
          'processId': this.processId,
        }
        this.loading = true;
        requestActiveLicense.submitActivation(param).then(res =>{
          this.loading = false;
          if (res.code == '0') {
            this.activateState = true
            this.$refs.commonRef.setTableData(res.res || []);
            // this.$notify({
            //   title: '成功',
            //   message: res.msg || '操作成功',
            //   type: 'success',
            // });
          }
        }).catch(err =>{
          this.$notify({
            title: '失败',
            message: '操作失败',
            type: 'error',
          });
        })
      }).catch(()=>{
        console.log('失败');
      })
    },
  }
}
</script>
<style lang="less" scoped>
.licenseWrap{
  background: #FFFFFF;
    // margin: 20px;
  height: 100%;
  // max-width: 1200px;
  display: flex;
  flex-direction: column;
  .licenseConentWrap{
    margin: 0 auto;
    // margin: 0 291px;
    // height: 100%;
    overflow: hidden;
    flex: 1;
    display: flex;
    flex-direction: column;
    @media (min-width: 768px){
      width: 750px;
    }
    @media (min-width: 992px){
      width: 970px;
    }
    @media (min-width: 1200px){
      width: 1200px;
    }
    // 小于 1532 px
    @media screen and (max-width: 1532px) {
      margin-top: 32px;
    }

    // min-width: 1200px;
    .licenseTitle{
      height: 25px;
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      line-height: 25px;
      font-family: PingFangSC-Medium, PingFang SC;
      padding: 20px 0;
      .clickText{
        cursor: pointer;
        color: @currentColor;
      }
      .licenseTitleIcon{
        margin-left: 7px;
        cursor: pointer;
        font-size: 16px;
      }
    }
    .licenseHeader{
      width: 100%;
      height: 34px;
      line-height: 34px;
    }
    .licenseContent{
      flex: 1;
      padding: 16px 0;
    }
  }
  .licenseFooter{
    z-index: 99;
    // padding: 0 291px;
    width: 100%;
    height: 66px;
    background: #FFFFFF;
    box-shadow: 0px -4px 8px 0px rgba(66, 44, 82, 0.07);
    // text-align: right;
    display: flex;
    align-items: center;
    .footerWrap{
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      @media (min-width: 768px){
        width: 750px;
      }
      @media (min-width: 992px){
        width: 970px;
      }
      @media (min-width: 1200px){
        width: 1200px;
      }
    }
  
    // min-width: 1200px;
    .clickText{
      cursor: pointer;
      color: @currentColor;
    }
    .footerRight{
      flex: 1;
      text-align: right;
      .verifyCode{
        // margin-right: 15px;
      }
    }
    
  }
}

</style>